export default __webpack_public_path__ + "static/media/visibility.8d8c868a.svg";